export default "__VITE_ASSET__DuKc7bj4__"